import React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { LeadReportsPage } from './main/LeadReportsPage';

export const LeadReports = () => (
  <>
    <DocumentHead title='Leads Report' />
    <PageTemplate main={<LeadReportsPage />} />
  </>
);
